import {useEffect, useState} from 'react';
import Mood from "../assets/png/mood.webp";
import Noize from "../assets/png/noize-tile.webp";

const urls = [Mood, Noize];

const IMAGE_TIMEOUT = 15000;
const RETRY_DELAY = 1000;

export default function usePreloadImages() {
    const [ready, setReady] = useState(false);

    useEffect(() => {
        let cancelled = false;

        const loadImage = src => new Promise((resolve, reject) => {
            const img = new Image();
            const timeoutId = setTimeout(() => {
                img.src = '';
                reject(new Error(`Timeout loading ${src}`));
            }, IMAGE_TIMEOUT);
            img.onload = () => {
                clearTimeout(timeoutId);
                resolve();
            };
            img.onerror = () => {
                clearTimeout(timeoutId);
                reject(new Error(`Failed loading ${src}`));
            };
            img.src = src;
        });

        const loadCriticalImages = async () => {
            while (!cancelled) {
                try {
                    await Promise.all(urls.map(loadImage));
                    if (!cancelled) setReady(true);
                    return;
                } catch {
                    await new Promise(resolve => setTimeout(resolve, RETRY_DELAY));
                }
            }
        };

        loadCriticalImages();
        return () => { cancelled = true; };
    }, []);

    return ready;
}
